import {AdminUser, RequestDenied} from "../http/protocol";
import {combineReducers} from "redux";
import {createAndDispatch} from "../RootReducer";

export enum UserStatus {
    LOGGED_OUT,
    IN_PROGRESS,
    LOGGED_IN,
    LOGIN_ERROR
}
export enum UserPasswordStatus {
    NONE,
    FORCE_CHANGE_PASSWORD,
    INVALID_PASSWORD_CHANGE,
    IN_PROGRESS
}

export interface UserSessionToken {
    token? : string;
    expiration? : Date;
}

export interface UserStoreState {
    user? : AdminUser;
    status? : UserStatus;
    passwordStatus?: UserPasswordStatus;
    displayRequestForbidden? : boolean;
    activeRole? : string;
    activeOperator? : number;
    permissions? : { [key:string] : boolean };
    expandedMenu?: boolean;
    userToken? :  UserSessionToken;
    requestDenied?: RequestDenied;
}
export interface ReduxAction<T> {
    type? : string;
    payload: T;
    error?: boolean;
    meta?: any;
    createdTime: number;
}
export interface ApplicationState {
    user : UserStoreState;
}

export const appReducer = combineReducers<ApplicationState>({
    user : userReducer
});


export function createAction<T>(type : any, payload : T) {
    return {
        type : type,
        payload : payload,
        createdTime : Date.now()
    }
}



export const HANDLE_LOGIN = "HANDLE_LOGIN";
export function handleLogin() {
    return createAndDispatch(HANDLE_LOGIN, {});
}

export const HANDLE_LOGIN_ERROR = "HANDLE_LOGIN_ERROR";
export function handleLoginError() {
    return createAndDispatch(HANDLE_LOGIN_ERROR, {});
}
export const HANDLE_NOT_LOGGED_IN = "HANDLE_NOT_LOGGED_IN";
export function handleNotLoggedIn() {
    return createAndDispatch(HANDLE_NOT_LOGGED_IN, {});
}
export const HANDLE_FORBIDDEN_REQUEST  = "HANDLE_FORBIDDEN_REQUEST";
export function handleForbiddenRequest(requestDenied: RequestDenied) {
    return createAndDispatch(HANDLE_FORBIDDEN_REQUEST, requestDenied);
}
export const HANDLE_RESET_FORBIDDEN_STATUS = "HANDLE_RESET_FORBIDDEN_STATUS";
export function handleResetForbiddenStatus() {
    return createAndDispatch(HANDLE_RESET_FORBIDDEN_STATUS, {});
}

export const HANDLE_LOGIN_SUCCESS = "HANDLE_LOGIN_SUCCESS";
export function handleLoginSuccess(w : { user : AdminUser, permissions : any, userToken : UserSessionToken}) {
    return createAndDispatch(HANDLE_LOGIN_SUCCESS, w);
}

export const HANDLE_FORCE_CHANGE_PASSWORD = "HANDLE_FORCE_CHANGE_PASSWORD"
export function handleForceChangePassword() {
    return createAndDispatch(HANDLE_FORCE_CHANGE_PASSWORD, {});
}

export const INVALID_PASSWORD_CHANGE = "INVALID_PASSWORD_CHANGE"
export function handleInvalidPasswordChange() {
    return createAndDispatch(INVALID_PASSWORD_CHANGE, {});
}

export const TOGGLE_MENU = "TOGGLE_MENU";
export function toggleMenu(show : boolean) {
    return createAndDispatch("TOGGLE_MENU", show);
}
export const HANDLE_PASSWORD_CHANGE_IN_PROGRESS = "HANDLE_PASSWORD_CHANGE_IN_PROGRESS";
export function handlePasswordChangeInProgress() {
    return createAndDispatch(HANDLE_PASSWORD_CHANGE_IN_PROGRESS, {});
}

export function userReducer(state : UserStoreState = {expandedMenu : false, status : UserStatus.LOGGED_OUT, passwordStatus : UserPasswordStatus.NONE}, action : ReduxAction<any>) {
    switch (action.type) {
        case "TOGGLE_MENU":
            return Object.assign({}, state, { expandedMenu : action.payload})
        case "HANDLE_PASSWORD_CHANGE_IN_PROGRESS":
            return Object.assign({}, state, { status : UserStatus.LOGGED_OUT, passwordStatus : UserPasswordStatus.IN_PROGRESS});
        case "HANDLE_FORCE_CHANGE_PASSWORD":
            return Object.assign({}, state, { status : UserStatus.LOGGED_OUT, passwordStatus : UserPasswordStatus.FORCE_CHANGE_PASSWORD});
        case "INVALID_PASSWORD_CHANGE":
            return Object.assign({}, state, { status : UserStatus.LOGGED_OUT, passwordStatus : UserPasswordStatus.INVALID_PASSWORD_CHANGE});
        case "HANDLE_LOGIN":
            return Object.assign({}, state, { status : UserStatus.IN_PROGRESS});
        case "HANDLE_LOGIN_ERROR":
            return Object.assign({}, state, {
                status : UserStatus.LOGIN_ERROR
            });
        case "HANDLE_NOT_LOGGED_IN":
            return Object.assign({}, state, {
                status : UserStatus.LOGGED_OUT,
                user : null,
                permissions : null
            })
        case "HANDLE_FORBIDDEN_REQUEST":
            return Object.assign({}, state, { displayRequestForbidden : true, requestDenied : action.payload });
        case "HANDLE_LOGIN_SUCCESS":
            let usr = {
                status : UserStatus.LOGGED_IN,
                user : action.payload.user,
                permissions : action.payload.permissions,
                passwordStatus : UserPasswordStatus.NONE,
                userToken: action.payload.userToken
            };
            return Object.assign({}, state , usr)
        case "HANDLE_RESET_FORBIDDEN_STATUS":
            return Object.assign({}, state, { displayRequestForbidden : false });

        default:
            return state;

    }
}


